import { render, staticRenderFns } from "./createFolderDialog.vue?vue&type=template&id=6c8c6000&"
import script from "./createFolderDialog.vue?vue&type=script&lang=js&"
export * from "./createFolderDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports